import {OrderService,MovieService,RegionService} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'
export default {

    props: {
        order: Object,
        cinema: Object,
        activeOrder: Boolean,
    },

    data(){
        return {
            movie: {},
            // pendingSession: {},
            toggleDeleteDialog: false,
            deleteId: null,
            regions:null,
            loadingDelete: false
        }
    },

    methods: {
        promtDelete(deleteId) {
            this.toggleDeleteDialog = true
            this.deleteId = deleteId
        },

        cancelDelete() {
            this.toggleDeleteDialog = false
            this.deleteId = null
        },

        confirmDelete() {
            this.loadingDelete = true
            this.toggleDeleteDialog = false
            OrderService.removeSession(this.order.Session.SessionId).then(
                (cancelled) => {
                    this.loadingDelete = false
                    this.$emit('deleteMovie')
                }
            )
            // this.$router.push({path: '/'})
        }
    },

    computed: {
        ticketsGrouped(){
            if(!this.order || !this.order.Tickets) return []

            var tickets = this.order.Tickets.reduce((collection, ticket)=> {

                let key = ticket.Description;
                collection[key] = collection[key] || {
                        Description: ticket.Description,
                        PriceInCents: 0,
                        Quantity: 0
                    };
                collection[key].PriceInCents += ticket.PriceCents ;
                collection[key].Quantity++;
                return collection;
            }, {});

            return tickets;
        },
        total(){
            if(!this.order || !this.order.Tickets) return 'R0.00'

            for(let t = 0; t <= this.order.Tickets.length; t++) {
                let ticket = this.order.Tickets[t]
            }


            var totalTicketPrice = this.order.Tickets.reduce((v,t)=>v += t.price,0)
            var ConcessionTotal =this.order && this.order.Concessions ? this.order.Concessions.reduce((c, t)=>c+=(t.PriceInCents * t.Quantity),0) : 0
            totalTicketPrice += ConcessionTotal / 100;
            var priceFormatted = (totalTicketPrice).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            return `R${priceFormatted}`
        },

    },
    created(){

    },


}



// WEBPACK FOOTER //
// ./src/components/performance/performance-info-main/performance-info-main.js